// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"806":"1d98484d","907":"13d34cad"}[chunkId] + ".chunk.js";
};